<template>
  <RevAccordionList :has-external-borders>
    <FaqItem :answers="faqItem1" :question="translations.section2Question1" />
    <FaqItem :answers="faqItem2" :question="translations.section2Question2" />
    <FaqItem :answers="faqItem3" :question="translations.section2Question3" />
  </RevAccordionList>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { RevAccordionList } from '@ds/components/AccordionList'

import FaqItem from '../FaqItem/FaqItem.vue'

import translations from './BatteryFaq.translations'

const { hasExternalBorders = true } = defineProps<{
  hasExternalBorders?: boolean
}>()

const faqItem1 = computed(() => {
  return [
    { paragraph: translations.section2Answer1Paragraph1 },
    { paragraph: translations.section2Answer1Paragraph2 },
    {
      paragraph: translations.section2Answer1Paragraph3,
      link: translations.section2Answer1Paragraph3Link,
      linkText: translations.section2Answer1Paragraph3LinkText,
    },
  ]
})

const faqItem2 = computed(() => {
  return [
    { paragraph: translations.section2Answer2Paragraph1 },
    { paragraph: translations.section2Answer2Paragraph2 },
    { paragraph: translations.section2Answer2Paragraph3 },
  ]
})

const faqItem3 = computed(() => {
  return [
    { paragraph: translations.section2Answer3Paragraph1 },
    {
      paragraph: translations.section2Answer3Paragraph2,
      link: translations.section2Answer3Paragraph2Link,
      linkText: translations.section2Answer3Paragraph2LinkText,
    },
    {
      paragraph: translations.section2Answer3Paragraph3,
    },
  ]
})
</script>
